import jwtDecode from "jwt-decode";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Notification from "../../components/shared/Notification";

const ProtectedRoutes = ({
  isAllowed = true,
  isTokenBasePermissions = false,
  tokenPermissions = { role: null, property: null },
  redirectedPath = "/",
  component,
}) => {
  let storage = localStorage.getItem("token");
  if (!storage) {
    Notification("Error", "No token found! Please login again!", "error");
    return <Navigate to={"/"} replace />;
  }
  let token = jwtDecode(storage);

  /*
   * isAllowed - Abstract Guard For Rendering Protected Component.
   * Applicable for permissions
   *  Default =  True
   */

  if (!isAllowed) {
    Notification("Error", "You are not permitted to view this page!", "error");

    return <Navigate to={redirectedPath} replace />;
  }
  /*
   * isTokenizedPermissionType - Abstract Guard For Rendering Protected Component.
   * Applicable for permissions using token
   * Default =  False
   */

  if (isTokenBasePermissions) {
    /*
     * Checks token if it contains the same role
     * Returns component children
     * Property - is the token's property that contains the role
     * Role - is the role that must be the same with the property otherwise redirects
     *  */

    let property = tokenPermissions?.property;
    if (token && token[property] === tokenPermissions?.role) {
      return component ? component : <Outlet />;
    } else {
      Notification(
        "Error",
        "You are not permitted to view this page!",
        "error"
      );

      return <Navigate to={redirectedPath} replace />;
    }
  }

  /*
   * An <Outlet> should be used in parent route
   * elements to render their child route elements.
   *
   * Re-routes back to the former page if condition is not met
   */

  return component ? component : <Outlet />;
};

export default ProtectedRoutes;
